














import { Vue, Component } from 'vue-property-decorator';
import CamaraDashboard from '@/pantallas/Camaras/Dashboard/CamaraDashboard.vue';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';
@Component({
  components: { DashboardComponent: CamaraDashboard },
})
export default class CamaraVODPantalla extends Vue {
  moduleType: string = '';
  created() {
    var self = this;
    CamaraEventBus.$on('reloadComponent', () => {
      //self.chargePatentsCamera();
      let url = new URL(window.location.href);
      self.changedModule();
    });
  }

  mounted() {
    this.changedModule();
  }

  changedModule() {
    let url = new URL(window.location.href);
    this.moduleType =
      url.searchParams.get('m') == null
        ? 'Monitoreo Dispositivos Cámaras'
        : 'Monitoreo Dispositivos Fatiga y Distracción';
  }
}
